
import { SubjectSelector, SubjectTypeSelector,
         ProgramSelector,
         FeatureTypeSelector } from "@Beasted1010/pivotal-wisdom";


// TODO: Move to a type file... ?
interface IFetchOptions {
  userId?: string,

  subjectSelector?: SubjectSelector,
  programSelector?: ProgramSelector,
  featureSelector?: FeatureTypeSelector,

  type?: SubjectTypeSelector,

  organizeBy?: string,
  recurringOnly?: boolean,

  signal?: AbortSignal
}


async function fetchSubjectData( {subjectSelector, type, signal}: IFetchOptions ) {
  // TODO: ADD CACHING -- Otherwise, re-fetching from Server...


  const subjectsURI = `/api/v1/content/subjects/${subjectSelector}/lessons`;
  /*
  const queryParams = type == null ? null : `type=${type}`;

  const subjectsURI = (subjectSelector == null)
    ? `http://localhost:7777/api/v1/content/subjects?${queryParams}`
    : `http://localhost:7777/api/v1/content/subjects/${subjectSelector}/lessons`;
    */

  const subjectData = await fetch( subjectsURI, {
    signal: signal,
    method: "GET",
    headers: {
      "Content-Type": "application/json"
    },
    credentials: "include", // Include Cookies in Cross Origin Requests (TODO: May not need this once FrontEnd and BackEnd merged since FE is on Port 3000 and BE is on 7777, thus 'different Origins')
  }).then( response => {
    if( response.ok ) return response.json(); // Convert to JSON and return
    return response.json().then( json => Promise.reject(json) ); // Fetch doesn't fail on it's own (see above video)
  }).then( ( data ) => {

    //console.log( "RESPONSE DATA", data );
    return data;
  }).catch( error => {
    console.error( error );
  });

  return subjectData;
}

async function fetchSubjectsMetadata( {type, signal}: IFetchOptions ) {

  const URL = `/api/v1/content/subjects/metadata?type=${type}`;

  const response = await fetch( URL, {
    signal,

    credentials: "include", // Include Cookies in Cross Origin Requests (TODO: May not need this once FrontEnd and BackEnd merged since FE is on Port 3000 and BE is on 7777, thus 'different Origins')
  });

  const data = await response.json();
  const subjectsMetadata = data.subjectsMetadata;

  //console.log("METADATA RESPONSE DATA", data);

  return subjectsMetadata;
}


async function fetchProgramFeatureData( {subjectSelector, programSelector, featureSelector, signal}: IFetchOptions ) {
  const URL = `/api/v1/content/features/feature/${featureSelector}?subjectSelector=${subjectSelector}&programSelector=${programSelector}`;

  const response = await fetch( URL, {
    signal,

    credentials: "include", // Include Cookies in Cross Origin Requests (TODO: May not need this once FrontEnd and BackEnd merged since FE is on Port 3000 and BE is on 7777, thus 'different Origins')
  });

  const data = await response.json();
  const featureData = data.featureData;

  //console.log("FEATURE RESPONSE DATA", data);

  return featureData;
}

async function fetchAllFeaturesWithProgressForProgram( {subjectSelector, programSelector, signal}: IFetchOptions ) {
  const URL = `/api/v1/content/features/?subjectSelector=${subjectSelector}&programSelector=${programSelector}&includeProgress=true`;

  const response = await fetch( URL, {
    signal,

    credentials: "include", // Include Cookies in Cross Origin Requests (TODO: May not need this once FrontEnd and BackEnd merged since FE is on Port 3000 and BE is on 7777, thus 'different Origins')
  });

  const data = await response.json();
  const featuresData = data.featuresData;
  const userProgress = data.userProgress;

  //console.log("FEATURES RESPONSE DATA", data);

  return { featuresData, userProgress };
}


async function fetchVideoURL( ) {

  const URL = "/api/v1/videos/test"; // TODO: Variable for Server Domain

  const response = await fetch( URL );

  const data = await response.json();
  const videoURL = data.videoURL;

  return videoURL;
}


async function fetchUserValidation() {
  const URL = "/api/v1/users/valid";

  const response = await fetch( URL, {
    credentials: "include", // Include Cookies in Cross Origin Requests (TODO: May not need this once FrontEnd and BackEnd merged since FE is on Port 3000 and BE is on 7777, thus 'different Origins')
  });
  //console.log( "RESPONSE", response );

  if( !response.ok ) {
    // TODO: ... Network Response was not OK
  }

  const data = await response.json();
  //console.log("DATA...", data);

  return data.valid;
}


async function fetchAuthCredentials( platform: string ) {
  const URL = `/api/v1/users/auth/credentials?platform=${platform}`;

  const response = await fetch( URL, {
    //credentials: "include", // TODO: Shouldn't need Credentials as not verifyToken on Server (since this API be used when not Logged in yet)
  });

  if( !response.ok ) {
    // TODO: ... Network Response was not OK
  }

  const data = await response.json();

  return data.credentials;
}


async function fetchCoachingAvailability( {organizeBy, recurringOnly, signal}: IFetchOptions ) {
  const organizeByQueryParam = organizeBy ? `organizeBy=${organizeBy}` : "";
  const recurringOnlyQueryParam = recurringOnly ? `recurringOnly=${recurringOnly}` : "";
  const queryParams = `${organizeByQueryParam}${recurringOnlyQueryParam ? `&${recurringOnlyQueryParam}` : ""}`;
  const scheduleAvailabilityEndpoint = `/api/v1/coaching/schedule/availability?${queryParams}`;

  const result = await fetch( scheduleAvailabilityEndpoint, {} );

  if( result == null || !result.ok ) { // TODO: Other/better ERROR HANDLING (?)
    console.error( "ERROR Retrieving Availability", result.status);
    throw new Error( "Fetch Coaching Availability Failed", { cause: `Received: ${result}` } );
  }

  const responseBody = await result.json();

  return responseBody.availability;
}


interface FetchLandingPageOptions extends IFetchOptions {
  category: string; // TODO: USE LandingPageCategory ENUM FROM SERVER... (add to Shared Library)
  identifier: any; // TODO: LandingPageContext has ILandingPageIdentifier Interface -- Consider adding to Shared Library and use here, too
}
//async function fetchLandingPageData( {type, subjectSelector, programSelector, signal}: IFetchOptions ) {
async function fetchLandingPageData( {category, identifier, signal}: FetchLandingPageOptions ) {

  const params = new URLSearchParams();

  params.append('category', category);
  if( identifier.subjectType ) params.append('subjectType', identifier.subjectType);
  if( identifier.subjectSelector ) params.append('subjectSelector', identifier.subjectSelector);
  if( identifier.programSelector ) params.append('programSelector', identifier.programSelector);
  if( identifier.featureSelector ) params.append('featureSelector', identifier.featureSelector);

  const URL = `/api/v1/content/landing?${params.toString()}`; // TODO: Should this be "/content/landing"? May not make sense, given that UI endpoint doesn't have that (which I left out since want it under a different endpoint... ??)


  const response = await fetch( URL, {
    signal,

    credentials: "include", // Include Cookies in Cross Origin Requests (TODO: May not need this once FrontEnd and BackEnd merged since FE is on Port 3000 and BE is on 7777, thus 'different Origins')

    //body: JSON.stringify({ category, identifier }),
  });

  const data = await response.json();
  const landingPageData = data.landingPageData;

  //console.log("METADATA RESPONSE DATA", data);

  return landingPageData;
}


async function fetchUserProgress( {userId, subjectSelector, programSelector, featureSelector, signal}: IFetchOptions ) {
  let URL = `/api/v1/users/${userId}/progress/${subjectSelector}/${programSelector}`;
  URL += featureSelector ? `/${featureSelector}` : "";

  const response = await fetch( URL, {
    signal,

    credentials: "include", // Include Cookies in Cross Origin Requests (TODO: May not need this once FrontEnd and BackEnd merged since FE is on Port 3000 and BE is on 7777, thus 'different Origins')
  });

  const data = await response.json();
  const userProgress = data.userProgress;

  return userProgress;
}



async function fetchPlatform( selector: string ) {
  const URL = `/api/v1/content/platform?selector=${selector}`;

  const response = await fetch( URL );

  const data = await response.json();
  const platform = data.platform;

  return platform;
}


async function fetchPlatformContent( category: string ) {
  const URL = `/api/v1/content/platform/business?category=${category}`;

  const response = await fetch( URL );

  const data = await response.json();
  const platformContent = data.platformContent;

  return platformContent;
}


async function fetchPortfolioData( platformSelector: string ) {
  const URL = `/api/v1/content/portfolio?platformSelector=${platformSelector}`;

  const response = await fetch( URL );

  const data = await response.json();
  const portfolioData = data.portfolioData;

  return portfolioData;
}






export {
  fetchSubjectData,
  fetchSubjectsMetadata,

  fetchProgramFeatureData,
  fetchAllFeaturesWithProgressForProgram,

  fetchVideoURL,

  fetchUserValidation,
  fetchAuthCredentials,

  fetchCoachingAvailability,

  fetchLandingPageData,

  fetchUserProgress,

  fetchPlatform,
  fetchPlatformContent,

  fetchPortfolioData
}
